import React, { useState, useEffect, useMemo } from 'react';
import { getTimeUntil7PM } from '../data/mockData';
import { useAuth } from '../context/AuthContext';

export const getTimeFromDraw = (nextDrawAt) => {
  if (!nextDrawAt) return getTimeUntil7PM();

  const target = new Date(nextDrawAt);
  if (Number.isNaN(target.getTime())) {
    return getTimeUntil7PM();
  }

  const now = new Date();
  const diff = Math.max(target.getTime() - now.getTime(), 0);

  const hours = Math.floor(diff / (1000 * 60 * 60));
  const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
  const seconds = Math.floor((diff % (1000 * 60)) / 1000);

  return { hours, minutes, seconds };
};

export const useCountdownTime = () => {
  const { nextDrawAt } = useAuth();
  const [time, setTime] = useState(getTimeUntil7PM());

  const timerSource = useMemo(() => nextDrawAt, [nextDrawAt]);

  useEffect(() => {
    const update = () => setTime(getTimeFromDraw(timerSource));
    update();
    const interval = setInterval(update, 1000);
    return () => clearInterval(interval);
  }, [timerSource]);

  return time;
};
